import { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router';

import { ROUTES } from '@/constants';
import { useRouteScope } from '@/contexts/app-context/hooks';
import { useCachedRegionSeason } from '@/hooks';

import { useGetRegionOptions } from '../Topbar/components/SelectRegion/hooks';
import { useGetCropSeasonOptions } from '../Topbar/components/SelectSeason/hooks';

const DataInitializer = () => {
  const { value, setValue } = useCachedRegionSeason();
  const { regionId } = useRouteScope();

  const hasRouteScope = Boolean(regionId);

  const { options: regionOptions, isLoading: loadingRegionOptions } =
    useGetRegionOptions();

  const defaultRegion = regionOptions?.[0]?.value;
  // This list only ever feeds the fallback scope below, so it is fetched only
  // when there is no cached scope to fall back from. `defaultRegion` is
  // whatever the API returned first, not the routed region — fetching it
  // unconditionally puts a request whose result is discarded on every boot.
  const { options: cropSeasonOptions, isLoading: loadingCropOptions } =
    useGetCropSeasonOptions({
      regionId: defaultRegion?.toString(),
      enabled: !value && !hasRouteScope
    });

  useEffect(() => {
    if (
      !value &&
      !hasRouteScope &&
      regionOptions.length &&
      cropSeasonOptions.length
    ) {
      setValue({
        region: regionOptions[0].value,
        season: cropSeasonOptions[0].value
      });
    }
  }, [value, hasRouteScope, regionOptions, cropSeasonOptions, setValue]);

  if (!loadingRegionOptions && !regionOptions.length) {
    return <Navigate to={ROUTES.PENDING_ACCESS} replace />;
  }

  if (hasRouteScope) {
    return <Outlet />;
  }

  if (!value) {
    if (
      !loadingRegionOptions &&
      !loadingCropOptions &&
      !cropSeasonOptions.length
    ) {
      return <Navigate to='not-found' replace />;
    }

    return <div />;
  }

  return <Outlet />;
};

export default DataInitializer;
